module.exports = __webpack_public_path__ + "static/img/vector_smart_object.abe81f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/vector_smart_object.png
// module id = T8e0
// module chunks = 6